import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const VIDEO_CONTENT_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.PATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.GREBooster,
  PlatformSlug.DLOSCE
)

export const isVideoContentAvailable = (slug?: PlatformSlug) => isFeatureAvailable(VIDEO_CONTENT_CONFIG, slug)

export const AAMC_SOLUTION_VIDEOS_CONFIG = enabledOn(PlatformSlug.CARSBooster)

export const isAamcSolutionVideosAvailable = (slug?: PlatformSlug) =>
  isFeatureAvailable(AAMC_SOLUTION_VIDEOS_CONFIG, slug)
